// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"15eaad71a159d006","777":"c71ff19c5e695dc6"}[chunkId] + ".js";
};